var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91669 5.83325L8.72079 10.5961C9.27176 10.9818 9.54725 11.1746 9.84691 11.2493C10.1116 11.3153 10.3884 11.3153 10.6531 11.2493C10.9528 11.1746 11.2283 10.9818 11.7793 10.5961L18.5834 5.83325M5.91669 16.6666H14.5834C15.9835 16.6666 16.6836 16.6666 17.2183 16.3941C17.6887 16.1544 18.0712 15.772 18.3109 15.3016C18.5834 14.7668 18.5834 14.0667 18.5834 12.6666V7.33325C18.5834 5.93312 18.5834 5.23306 18.3109 4.69828C18.0712 4.22787 17.6887 3.84542 17.2183 3.60574C16.6836 3.33325 15.9835 3.33325 14.5834 3.33325H5.91669C4.51656 3.33325 3.81649 3.33325 3.28171 3.60574C2.81131 3.84542 2.42885 4.22787 2.18917 4.69828C1.91669 5.23306 1.91669 5.93312 1.91669 7.33325V12.6666C1.91669 14.0667 1.91669 14.7668 2.18917 15.3016C2.42885 15.772 2.81131 16.1544 3.28171 16.3941C3.81649 16.6666 4.51656 16.6666 5.91669 16.6666Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.03a28c89d1335d4cfad244ac508fc268.svg";
export { ForwardRef as ReactComponent };